import { notification } from 'antd'
import i18n from 'i18next'
import { generateDetailedMessageError } from 'modules/core/utils'

export const notifyMappingError = (error) =>
  notification.error({
    message: i18n.t('FEEDBACK_DEFAULT_ERROR'),
    description: generateDetailedMessageError(error),
    duration: 0,
  })
